import React, { FC } from "react";
import { Icon } from "@iconify/react";
import { BookItem, ChapterItem } from "type";
import convertDurationToHHMMSS from "utils/convertDurationToHHMMSS";
import Button from "_components/Button/Button";
import { useMusicPlayer } from "../../hooks/useMusicPlayer";

interface WidgetBookChapterItemProps {
  className?: string;
  chapter?: ChapterItem;
}


const WidgetBookChapterItem: FC<WidgetBookChapterItemProps> = ({
                                                                 className = "bg-neutral-100 dark:bg-neutral-100",
                                                                 chapter = {}
                                                               }) => {
  let icon: string = "mdi:book-open-page-variant";
  if (chapter.chapterType === "audio") {
    icon = "mdi:headphones";
  }
  const {
    setCurrentChapterId,
  } = useMusicPlayer();

  // STATE

  const handleClickButton = (chapterId: any) => {
    setCurrentChapterId(chapterId);
  };
  return (
    <div
      className={`nc-CardAuthor text-sm items-center px-2 py-2 ${className}`}
    >
      <div className="relative grid grid-cols-5 gap-4 items-center">
        <div className={"sm:col-span-2 col-span-5"}>
          <Icon icon={icon} className={"inline-flex"} /> {chapter.name}
        </div>
        <div className={"md:col-span-1 col-span-2"}>
          {chapter.publishDate}
        </div>
        <div className={"col-span-1"}>
          {convertDurationToHHMMSS(chapter.duration)}
        </div>
        <div className={"md:col-span-1 col-span-2 text-right"}>
          <Button sizeClass={"p-1 pr-2 pl-2 m-0"} className={"items-center rounded-none mr-3"}
                  fontSize={"text-sm font-small"} pattern={"third"}>
            <Icon icon="material-symbols:share" className={"inline-flex"} />
          </Button>
          <Button sizeClass={"p-1 pr-0 pl-2 m-0 mr-2"}
                  className={"items-center rounded-none"}
                  fontSize={"text-sm font-small"} pattern={"third"}
                  onClick={() => {
                    handleClickButton(chapter.id);
                  }}
          >
            <Icon icon={"solar:play-bold"} className={"inline-flex mr-2 text-sm"} />
          </Button>

        </div>
      </div>
    </div>
  );
};

export default WidgetBookChapterItem;
